import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  Toolbar, IconButton, 
} from '@mui/material';
import { makeStyles, useTheme } from '@mui/styles';
import ToolbarStyles from './utils/ToolbarStyles.js';
import MenuIcon from '@mui/icons-material/Menu';
import { useTranslation } from '../common/components/LocalizationProvider';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Button from '@mui/material/Button';
import {ReactComponent as UserIcon} from '../resources/images/track2you/Icons_User_Outline.svg';
import {ReactComponent as SettingsIcon} from '../resources/images/track2you/Icons_Settings.svg';
import {ReactComponent as WorkAreaIcon} from '../resources/images/track2you/Icons_Work_Area.svg';
import {ReactComponent as ActivityMapIcon} from '../resources/images/track2you/Icons_Activity_Map.svg';
import {ReactComponent as LocationIcon} from '../resources/images/track2you/Icons_Location-06.svg';
import {ReactComponent as NotificationIcon} from '../resources/images/track2you/Icons_Notification.svg';

import { sessionActions } from '../store';
import { nativePostMessage } from '../common/components/NativeInterface';

const MainToolbar = ({

}) => {
  const user = useSelector((state) => state.session.user);
  const classes = ToolbarStyles();
  const theme = useTheme();
  const navigate = useNavigate();
  const t = useTranslation();
  const dispatch = useDispatch();


  const [anchorEl, setAnchorEl] = useState(null);

  const [state, setState] = React.useState({
    bottom: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const handleLogout = async () => {
    try {
        setAnchorEl(null);

        // Handle notification token removal logic
        const notificationToken = window.localStorage.getItem('notificationToken');
        if (notificationToken && !user.readonly) {
            window.localStorage.removeItem('notificationToken');
            const tokens = user.attributes.notificationTokens?.split(',') || [];
            if (tokens.includes(notificationToken)) {
                const updatedUser = {
                    ...user,
                    attributes: {
                        ...user.attributes,
                        notificationTokens: tokens.length > 1 ? tokens.filter((it) => it !== notificationToken).join(',') : undefined,
                    },
                };

                await fetch(`/api/users/${user.id}`, {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(updatedUser),
                });
            }
        }

        // Perform logout
        await fetch('/api/session', { method: 'DELETE' });

        // Call native post-message if applicable
        nativePostMessage('logout');

        //dispatch(sessionActions.updateUser(null)); // Clear state after navigation
        //dispatch(sessionActions.updateDevices(null)); // Clear state after navigation
        //dispatch(sessionActions.updateDriverInstructions(null)); // Clear state after navigation
        //dispatch(sessionActions.updateTotalCounts(null)); // Clear state after navigation

        navigate('/login');

        dispatch(resetSession());                           // Reset the Redux state
        sessionStorage.clear();  

        

    } catch (error) {
        console.error('Error during logout:', error);
    }
};


  const handleLinks = (event, value) => {
    switch (value) {
      case 'account':
        navigate(`/settings/user/${user.id}`);
        break;
      case 'settings':
        navigate('/settings/settingsPage');
        break;
      case 'work':
        navigate('/work/workPage');
        break;
      case 'activities':
        navigate('/activities/activitiesPage');
        break;
      case 'map':
        navigate('/map/mainMap');
        break;
      case 'notifications':
        navigate('/settings/notifications');
        break;
      case 'logout':
        handleLogout();
        break;
      default:
        break;
    }
  };

  const linksInfo = {
    first: {
      name: 'settings',
      title: 'Definições Gerais',
      icon: <SettingsIcon />,
    },

    second: {
      name: 'work',
      title: 'Área de trabalho',
      icon: <WorkAreaIcon />,
    },

    third: {
      name: 'activities',
      title: 'Mapa de atividades',
      icon: <ActivityMapIcon />,
    },

    four: {
      name: 'map',
      title: 'Localização',
      icon: <LocationIcon />,
    },

    five: {
      name: 'notifications',
      title: 'Notificações',
      icon: <NotificationIcon />,
    },
  }
  
  const list = (anchor) => (
    <Box
      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List onChange={handleLinks} className={classes.linkIcon}>

        {Object.keys(linksInfo).map((data, key) => (
          <ListItem key={"list"+linksInfo[data].name} disablePadding>
            <ListItemButton onClick={(event) => handleLinks(event, linksInfo[data].name)}>
              <ListItemIcon>
                {linksInfo[data].icon}
              </ListItemIcon>
              <ListItemText primary={linksInfo[data].title} />
            </ListItemButton>
          </ListItem>
        ))}        
      </List>

      <div className={classes.endSession} spacing={2} direction="row">
        <Button onClick={(event) => handleLinks(event, "logout")} className={classes.endSessionButton} variant="contained">Terminar Sessão</Button>
      </div>
    </Box>
  );

  const toolbarRef = useRef();

  return (
    <Toolbar ref={toolbarRef} className={classes.toolbar}>
      {['bottom'].map((anchor) => (
        <React.Fragment key={anchor}>
          <IconButton edge="start" onClick={toggleDrawer(anchor, true)}>
            <MenuIcon />
          </IconButton>
          <Drawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
          >
            {list(anchor)}
          </Drawer>
        </React.Fragment>
      ))}
      <IconButton className={classes.account} edge="end" onClick={(event) => handleLinks(event, "account")}>
        <UserIcon />
      </IconButton>
    </Toolbar>
  );
};

export default MainToolbar;
